import { getHeaders, checkStatus } from "../../../shared/services/shared";

export async function ingestionQueues() {
    return fetch(`${process.env.REACT_APP_API_URL}/genai/job/status`, {
      method: "GET",
      headers: await getHeaders({"component":"/user/setting"})
    })
      .then((response) => {
        if (!response.ok) {
          throw Error("HTTP error, status = " + response.status);
        }
        return response.json();
      })
      .then(checkStatus)
      .catch((error) => {
        return Promise.reject(error);
      });
}

// Cancel job queue by jobId and component
export async function cancelJobQueue(params) {
  return fetch(`${process.env.REACT_APP_API_URL}/genai/cancel/job`, {
    method: "POST",
    headers: await getHeaders({ component: params.component }),
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw Error("HTTP error, status = " + response.status);
      }
      return response.json();
    })
    .then(checkStatus)
    .catch((error) => {
      return Promise.reject(error);
    });
}
  